/* eslint-disable vue/custom-event-name-casing */
import { DOCUMENT_EVENTS, LIST_NAMES } from '../analytics/analyticsConst';
import { getItemListForProductID } from '../analytics/stores/itemList';
import { searchDataStorage } from '../analytics/stores/searchData';
import getAnalyticsEventCenter from '../common/getAnalyticsEventCenter';
import { assignUpidToProduct } from '../common/helpers/productModelHelpers';
import { getDoubleLookPIDWithoutSize } from '../common/utils/doubleLookUtils';
import App from './components/App.vue';
import EventBusConfig from './config/eventBusConfig';
import router from './router';
import store, { getters, types } from './store';
import { Vue, EventBus } from './vue';

const componentsForms = require('../components/forms');
const componentsClientSideValidation = require('../components/clientSideValidation');
const domUtils = require('../common/utils/dom');

const analyticsEventCenter = getAnalyticsEventCenter();

/**
 * Update page meta datas (title, description) with page properties that SFRA adds.
 *
 * @param {Object} { pageTitle, pageDescription } SFRA product or category
 */
function updatePageMetas(pageObject = {}) {
  window.document.title = pageObject?.pageTitle || '';
  domUtils.setMeta('description', pageObject?.pageDescription || '');
}

function initVueApp() {
  const vueApp = document.getElementById('vue-app');
  // If it is not found, then abort the creation of Vue instance
  // Example: Login page
  if (!vueApp) return;

  const data = JSON.parse(vueApp.dataset.vue);

  if (data?.TheProductList) {
    store.dispatch(types.productList.init, {
      productSearch: data.TheProductList,
      url: window.location,
    });
  }

  if (data?.TheProductDetails) {
    store.commit(types.product.update, {
      ...data.TheProductDetails,
    });
  }

  if (data?.TheProductCustomizer) {
    store.dispatch(types.productCustomizer.load, data.TheProductCustomizer);
  }

  if (data?.Account) {
    store.commit(types.account.init, data.Account);
  }

  if (data?.Cart) {
    store.dispatch(types.cart.init, data.Cart);
  }
  // eslint-disable-next-line no-unused-vars
  const vm = new Vue({
    el: '#vue-app',
    components: {
      App,
    },
    render(h) {
      return h(App);
    },
    store,
    router,
  });
}

// -------------------------------------------------------------------------
//  EventBus listeners & commands
// -------------------------------------------------------------------------

//
//  General related listeners
// -------------------------------------------------------------------------
EventBus.$on('header-popup:hide', () => {
  $('body').trigger('header-popup:hide');
});

EventBus.$on(EventBusConfig.events.router.willNavigate, ({ from, to }) => {
  analyticsEventCenter.publish(
    analyticsEventCenter.EVENTS.userWillNavigateDinamically,
    {
      from,
      to,
    },
  );
});

EventBus.$on(EventBusConfig.events.pageTitleLoaded, ({ pageTitle, pageType }) => {
  analyticsEventCenter.publish(
    analyticsEventCenter.EVENTS.pageLoadedDynamically,
    {
      pageTitle,
      pageType,
    },
  );
});

//
//  BaseProductTileQuickShop related listeners
// -------------------------------------------------------------------------
$('body').on('quickShop:afterAddSizeToCart',
  /**
   * Trigger EventBus event after adding size to cart
   * @param {jQuery.Event} e jQuery Event
   * @param {Object} payload Event payload
   * @param {Object} payload.productVariation attributeSelect() response
   * @param {FullProduct} payload.productVariation.product attributeSelect() product
   * @param {Object} payload.productVariation.resources Useful messages
   * @param {Object} payload.cartAddProduct Cart-AddProduct response
   * @param {Cart} payload.cartAddProduct.cart Cart model
   * @param {FullProduct} payload.cartAddProduct.product Variant full product
   * @param {string} payload.cartAddProduct.pliUUID UUID of the added line item
   */
  (e, { productVariation, cartAddProduct }) => {
    assignUpidToProduct(productVariation?.product);
    EventBus.$emit(EventBusConfig.events.BaseProductTileQuickShop.addedToCart, {
      productVariation,
      cartAddProduct,
    });
  });

//
//  TheProductDetails related listeners
// -------------------------------------------------------------------------
EventBus.$on(EventBusConfig.events.TheProductDetails.loaded, (product) => {
  updatePageMetas(product);

  const pidWithoutSize = getDoubleLookPIDWithoutSize(product.id);
  const list = getItemListForProductID(pidWithoutSize);
  const searchData = list === LIST_NAMES.search
    && searchDataStorage.getItem(pidWithoutSize);
  // Dispatch product view event for Analytics
  analyticsEventCenter.publish(
    analyticsEventCenter.EVENTS.productDetailsViewed,
    {
      product,
      list,
      searchData,
    },
  );
});

$('.header .search').on('click', (event) => {
  event.preventDefault();
  EventBus.$emit(EventBusConfig.commands.TheSearch.toggle);
  // Dispatch search engine session event for Analytics
  analyticsEventCenter.publish(
    analyticsEventCenter.EVENTS.searchSessionUsed,
    gaInfo.searchEngineType,
  );
});

EventBus.$on(EventBusConfig.events.TheProductDetails.zoomOpened, (zoomRequirements) => {
  $('body').trigger('the-product-details:image-zoom', zoomRequirements);
});

EventBus.$on(EventBusConfig.events.TheProductDetails.zoomClosed, () => {
  $('body').trigger('the-product-details:after-image-zoom-close');
});

EventBus.$on(EventBusConfig.events.TheProductDetails.colorSelected, (color, container) => {
  $('body').trigger('product:selectColor', {
    color,
    container: $(container),
  });
});

//
// BaseWishlistHeart related listeners
// -------------------------------------------------------------------------
EventBus.$on('wishlist-heart:clicked', (button, product) => {
  $('body').trigger('wishlist-heart:clicked', { button, product });
});

$('body').on('wishlist-heart:updated', (e, result) => {
  EventBus.$emit('wishlist-heart:updated', result);
});

$('body').on('wishlist-heart:update-from-cart', (e, data) => {
  EventBus.$emit('wishlist-heart:update-from-cart', data.productId, data.variationGroupId);
});

//
// BaseProductSlider related listeners
// -------------------------------------------------------------------------
EventBus.$on('base-product-slider:ready', () => {
  const productSliderReady = new CustomEvent(DOCUMENT_EVENTS.productSliderReady);
  document.dispatchEvent(productSliderReady);
});

//
//  TheProductList related listeners
// -------------------------------------------------------------------------
EventBus.$on(EventBusConfig.events.TheProductList.categoryChanged, (category) => {
  updatePageMetas(category);
});

EventBus.$on(EventBusConfig.events.TheProductList.columnModeChanged, () => {
  window.scrollTo(0, 0);
});

//
//  TheSearch related listeners
// -------------------------------------------------------------------------
const header = document.querySelector('#byl-header');
const headerOpenedSearchClass = 'header--search-open';
EventBus.$on(EventBusConfig.events.TheSearch.hidden, () => {
  header.classList.remove(headerOpenedSearchClass);
  analyticsEventCenter.publish(analyticsEventCenter.EVENTS.searchHidden);
});
EventBus.$on(EventBusConfig.events.TheSearch.shown, () => {
  header.classList.add(headerOpenedSearchClass);
  analyticsEventCenter.publish(analyticsEventCenter.EVENTS.searchShown);
});
EventBus.$on(EventBusConfig.events.TheSearch.toggled, () => {
  header.classList.toggle(headerOpenedSearchClass);
});
EventBus.$on(EventBusConfig.events.TheSearch.searched, (payload) => {
  // Insert query in search input
  analyticsEventCenter.publish(
    analyticsEventCenter.EVENTS.searchQueryInserted,
    payload,
  );

  // Search results (or not) after launching the query
  if (payload.search.count > 0) {
    analyticsEventCenter.publish(
      analyticsEventCenter.EVENTS.searchReturnedResults,
      payload,
    );
  } else {
    analyticsEventCenter.publish(
      analyticsEventCenter.EVENTS.searchReturnedNoResults,
      {
        query: payload.search.query,
        match: payload.search.match,
        isCached: payload.search.isCached,
      },
    );
  }
});

//
// BaseRMAStoreLocator listeners
// -------------------------------------------------------------------------
$('body').on('change', '.select-store-input', (e) => {
  const { storeInfo } = e.target.dataset;
  EventBus.$emit('base-rma-store-locator:select-store', {
    storeInfo,
  });
});

//
//  Vuex related
// -------------------------------------------------------------------------
EventBus.$on('product:color-updated', (productVariation) => {
  // When changing the color in PDP, the data is requested by a listener of
  // SFRA, not by router. So, url has to be updated.
  //
  // Update by means of History API to avoid unnecessary requests. Router is
  // not recommended because it will dispatch the loading of the full product
  // associated with the pid of this variation.
  const newUrl = productVariation.selectedProductUrl.split('?')[0];
  window.history.pushState(null, productVariation.pageTitle, newUrl);
});

//
//  SFRA Integration
// -------------------------------------------------------------------------
$('body').on('product:afterAttributeSelect', (e, payload) => {
  const productVariation = payload.data.product;
  const container = payload.container.get(0);
  assignUpidToProduct(productVariation);
  EventBus.$emit(
    EventBusConfig.commands.TheProductDetails.updateProduct,
    { product: productVariation, container },
  );
});
$('body').on('product:afterAddToCart',
  /**
   *
   * @param {Event} e Event
   * @param {Object} data Cart-AddProduct response
   * @param {Cart} data.cart Cart model
   * @param {FullProduct} data.product Variant full product
   * @param {string} data.pliUUID UUID of the added line item
   */
  (e, data) => {
    const item = data.cart.items?.find((i) => i.UUID === data.pliUUID);
    if (item) {
      store.commit(types.cart.addItem, item);
    }
  });

$('body').on('storeCart:updateItem',
  /**
   * Trigger update item quantity command
   * @param {jQuery.Event} e - Event
   * @param {object} payload - Cart
   * @param {Cart} payload.cart - Cart
   * @param {UUID} payload.UUID - UUID of the updated line item
   * @returns {void}
   */
  (e, payload) => {
    const item = payload.cart.items?.find((i) => i.UUID === payload.UUID);
    store.commit(types.cart.updateItem, item);
  });

$('body').on('storeCart:removeItem',
  /** storeCart:removeItem event handler
   * @param {jQuery.Event} e - Event object
   * @param {string} variantId - Removed line item ID (variant ID)
   */
  (e, variantId) => {
    store.commit(types.cart.removeItem, variantId);
    EventBus.$emit(
      EventBusConfig.events.BaseProductTileQuickShop.removedFromCart,
      variantId,
    );
  });

EventBus.$on(EventBusConfig.commands.cart.removeAllSizesOfProduct,
  /**
   * Handle remove product command
   * @param {string} variationGroupId
   */
  (variationGroupId) => {
    // eslint-disable-next-line import/no-named-as-default-member
    const getProductLineItems = store.getters[getters.cart.getProductLineItemsForVariationGroupId];
    // eslint-disable-next-line import/no-named-as-default-member
    const removeProductLineItemUrl = store.getters[getters.cart.removeProductLineItemUrl];
    const productLineItems = getProductLineItems(variationGroupId);
    productLineItems.forEach((productLineItem) => $('body').trigger('cart:removeProductLineItem', {
      removeProductLineItemUrl,
      productLineItem,
    }));
  });

EventBus.$on('cart:updateProductQty',
  ({
    updateQuantityUrl,
    productID,
    quantity,
    UUID,
  }) => $('body').trigger('cart:updateProductQty', {
    updateQuantityUrl,
    productID,
    quantity,
    UUID,
  }));

EventBus.$on('forms:init', () => {
  componentsForms.init();
  componentsClientSideValidation.init();
});

EventBus.$on('forms:validation', (form, playload) => {
  const formValidation = require('../components/formValidation');
  formValidation(form, playload);
});

// reset size selector
$('body').on('product:afterAddToCart', () => {
  EventBus.$emit(EventBusConfig.events.TheProductDetails.addedToCart);
  // lock changes on size-selector
  EventBus.$emit(EventBusConfig.commands.TheProductDetails.lookSizeSelector);

  setTimeout(() => {
    EventBus.$emit(EventBusConfig.commands.TheProductDetails.resetSizeSelector);
    // reset sfra size selector
    const $sfraSizeSelector = document.querySelector('.select-size');
    if ($sfraSizeSelector) $sfraSizeSelector.selectedIndex = -1;
  }, 1000);
});

export default initVueApp;
